export function getFormattedZipCode(str?: string) {
    return !str ? 
      '' 
      :
      str.replace(/\D/g, '')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{3})\d+?$/, '$1')
}